import { render } from "./AttrEditor.vue?vue&type=template&id=09c9374e"
import script from "./AttrEditor.vue?vue&type=script&lang=ts"
export * from "./AttrEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script